import React from 'react';
import {Trans} from 'react-i18next';
import _isEmpty from 'lodash/isEmpty';

export default function UploadResultMessage({uploadResponse, finishUpload}) {
  const successIds = [];
  const errorRowsMap = {};

  uploadResponse.forEach((ur, index) => {
    if (ur.status === 'success' && ur.productId) {
      successIds.push(ur.productId);
    } else {
      errorRowsMap[ur.index] = ur.errors;
    }
  });

  const hasErrors = Object.keys(errorRowsMap).length > 0;

  if (!finishUpload || _isEmpty(uploadResponse)) {
    return <div />;
  }

  return (
    <div className="kt-section">
      <div
        className="kt-section__content kt-section__content--solid"
        style={{
          borderLeft: hasErrors ? '4px solid  #fd397a' : '4px solid  #1dc9b7',
          backgroundColor: hasErrors
            ? 'rgba(253, 57, 122, 0.1)'
            : 'rgba(29, 201, 183, 0.1)',
        }}
      >
        <div className="d-flex kt-margin-t-10 kt-margin-b-10">
          <label className="d-flex align-items-center kt-font-bold">
            {hasErrors ? (
              <>
                <i
                  className="fa fa-exclamation-triangle text-danger kt-margin-r-10"
                  style={{fontSize: '28px'}}
                />
                <Trans i18nKey="p.s.addskincare.batch.import.upload.fail">
                  Import failed due to an unknown error. Please try again.
                </Trans>
              </>
            ) : (
              <>
                <i
                  className="fa fa-check-square text-success kt-margin-r-10"
                  style={{fontSize: '28px'}}
                />
                <Trans i18nKey="p.s.addskincare.batch.import.upload.success">
                  Import Successful.
                </Trans>
              </>
            )}
          </label>
        </div>
      </div>
    </div>
  );
}
